"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getSizeInPx = function getSizeInPx(_ref) {
  var theme = _ref.theme,
    size = _ref.size;
  if (typeof size === 'number') return "".concat(size, "px");
  return theme["size".concat(size[0].toUpperCase() + size.slice(1))];
};
var _default = getSizeInPx;
exports["default"] = _default;